export const HERO_CONTENT = {
  label: "Partnered engagements",
  headline: "Co-create impactful research and events",
  cta: "Partner with us",
};

export const INTRO_TEXT = {
  highlight:
    "Partner with IMA India to craft influential research and engagement platforms",
  text:
    "that reach senior decision-makers and elevate your brand’s thought leadership.",
};

export const INFO_BOXES = [
  {
    title: "Proprietary research",
    description:
      "Commissioned research focused on your company’s strategic priorities and business goals",
    href: "#proprietary-research",
  },
  {
    title: "Co-branded research",
    description:
      "Collaborate with IMA to craft insightful, high-impact studies and reports",
    href: "#co-branded-research",
  },
  {
    title: "Sponsored sessions",
    description:
      "Showcase your leadership and brand to 2,500+ senior leaders at curated IMA events",
    href: "#sponsored-sessions",
  },
];

export const PROPRIETARY_RESEARCH = {
  eyebrow: "Proprietary research",
  headline: "Lending an objective view",
  points: [
    {
      strong: "Custom, company/ industry specific studies",
      text:
        "addressing issues directly relevant to your business objectives",
    },
    {
      strong: "Conducted independently",
      text:
        "by IMA India’s research team, with analytical rigour and objectivity",
    },
    {
      strong: "For internal use or limited circulation",
      text:
        "informing strategy, policy, and business planning",
    },
  ],
  cta: "Request custom research",
};

export const CO_BRANDED_RESEARCH = {
  eyebrow: "Co-branded research",
  headline: "Our expertise; your insights",
  highlight:
    "Whitepapers combining IMA's research strength with partners' domain knowledge",
  text:
    "to address key business challenges and shape industry dialogue.",
  cta: "Collaborate on Research",
  sliderLabel: "Co-branded with",
};

export const SPONSORED_SESSIONS = {
  eyebrow: "Sponsored sessions",
  headline: "Showcase your leaders, win the stage",
  highlight:
    "Feature your thought leadership, products and services",
  text:
    "at exclusive sessions and curated events designed to connect with top-tier management audiences.",
  points: [
    {
      strong: "8 exclusive CXO conferences a year,",
      text:
        "in inspiring Indian and international settings",
    },
    {
      strong: "30+ expert-led sessions and workshops",
      text:
        "across six key Indian cities",
    },
    {
      strong: "Curated agendas, speakers and execution",
      text:
        "that resonate with CXOs",
    },
  ],
  linkText: "Explore IMA events",
  cta: "Collaborate on a sponsored session",
};

export const ADVERTISE_SECTION = {
  headline: "Advertise your brand to 1500+ companies",
  description: {
    reach: "100,000+",
    companies: "1500+ companies",
    text:
      "through creative ad placements across IMA publications and website",
  },
  contact: {
    label: "Contact us",
  },
};
